import { gql } from '@apollo/client';

export const ADD_ACTIVITY_LOG = gql`
  mutation addActivityLog(
    $studyId: String!
    $log: String!
    $category: String
  ) {
    addActivityLog(
      studyId: $studyId
      log: $log
      category: $category
    ) {
      message
    }
  }
`;

export const ASSIGN_MEDICAL_REFERRAL = gql`
  mutation assignMedicalReferral(
    $studyId: String!
    $referrer: PractitionerInputType
    $referralType: String
    $unassign: Boolean
  ) {
    assignMedicalReferral(
      studyId: $studyId
      referrer: $referrer
      referralType: $referralType
      unassign: $unassign
    ) {
      message
    }
  }
`;

export const ASSIGN_PRESCRIBER = gql`
  mutation assignPrescriber(
    $studyId: String!
    $prescriber: PractitionerInputType
    $unassign: Boolean
  ) {
    assignPrescriber(studyId: $studyId, prescriber: $prescriber, unassign: $unassign) {
      message
    }
  }
`;

export const CREATE_MEDICAL_REFERRAL = gql`
  mutation createMedicalReferral($studyId: String!, $referral: Boolean!) {
    createMedicalReferral(studyId: $studyId, referral: $referral) {
      message
    }
  }
`;

export const PENDING_MEDICAL_REFERRAL = gql`
  mutation pendingMedicalReferral($studyId: String!) {
    pendingMedicalReferral(studyId: $studyId) {
      message
    }
  }
`;

export const CREATE_NOTE = gql`
  mutation createHealthPractitionerNote($note: CreateHealthPractitionerNoteInputType!) {
    createHealthPractitionerNote(noteInput: $note) {
      noteObj {
        noteId
      }
    }
  }
`;

export const CREATE_PRESCRIPTION = gql`
  mutation createPrescription(
    $prescription: PrescriptionInput!
    $pharmacy: PreferredPharmacyInput!
  ) {
    createPrescription(prescriptionInput: $prescription, preferredPharmacyInput: $pharmacy) {
      prescription {
        prescriptionId
      }
    }
  }
`;

export const DELETE_PRESCRIPTION = gql`
  mutation ($prescriptionId: String!) {
    deletePrescription(prescriptionId: $prescriptionId) {
      prescription {
        prescriptionId
      }
    }
  }
`;
export const DELETE_NOTE = gql`
  mutation ($noteId: String!) {
    deleteHealthPractitionerNote(noteId: $noteId) {
      noteObj {
        noteId
      }
    }
  }
`;

export const UPDATE_CREATE_NOTE = gql`
  mutation updateHealthPractitionerNote($note: UpdateHealthPractitionerNoteInputType!) {
    updateHealthPractitionerNote(noteInput: $note) {
      noteObj {
        noteId
      }
    }
  }
`;

export const UPDATE_PRESCRIPTION = gql`
  mutation (
    $prescriptionId: String!
    $prescription: String
    $preferredPharmacy: PreferredPharmacyInput!
    $signature: String
    $pickupDate: String
    $pharmacyRepresentativeName: String
    $sentDate: String
  ) {
    updatePrescription(
      prescriptionId: $prescriptionId
      prescription: $prescription
      preferredPharmacyInput: $preferredPharmacy
      signature: $signature
      pickupDate: $pickupDate
      pharmacyRepresentativeName: $pharmacyRepresentativeName
      sentDate: $sentDate
    ) {
      prescription {
        prescriptionId
      }
    }
  }
`;

export const UPDATE_STUDY_STATUS = gql`
  mutation updateStudyStatus($studyId: String!, $statusList: [StatusInput]!) {
    updateStudyStatus(studyId: $studyId, statusList: $statusList) {
      message
    }
  }
`;

export const UPDATE_USER_PHN = gql`
  mutation updateUser($user: UserInput!, $userId: String!) {
    updateUser(user: $user, userId: $userId) {
      user {
        userId
      }
    }
  }
`;

export const CREATE_ISSUE = gql`
  mutation createIssue($issueInput: CreateIssueInputType!) {
    createIssue(issueInput: $issueInput) {
      status
    }
  }
`;

export const UPDATE_PRESCRIPTION_STATUS = gql`
  mutation updatePrescriptionStatus($studyId: String!, $prescriptionStatus: String!) {
    updatePrescriptionStatus(studyId: $studyId, prescriptionStatus: $prescriptionStatus) {
      message
    }
  }
`;


export const UPDATE_CONSULTING_STATUS = gql`
  mutation updateConsultingStatus(
    $studyId: String!,
    $scheduledStatus: String,
    $eventId: String,
    $inviteeId: String,
    $consultTime: Int,
  ) {
    updateConsultingStatus(
        studyId: $studyId,
        scheduledStatus: $scheduledStatus,
        eventId: $eventId,
        inviteeId: $inviteeId,
        consultTime: $consultTime
    ) {
      message
    }
  }
`;
